import React from 'react';
import AppBar from 'material-ui/AppBar';
import FlatButton from 'material-ui/FlatButton';

const style = {
  position: 'fixed',
  top: 0
};

export default class Header extends React.Component {
  render() {
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 480;

    if (isMobile) {
      return null;
    }

    return (
      <AppBar
        className="header"
        title={this.props.header}
        iconElementRight={
          <FlatButton
            label="Çıkış"
            onClick={this.props.onLogout}
            style={{ color: '#fff' }}
          />
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Header.jsx